import React from "react";
import { Link } from "react-router-dom";
import { Calendar, ClipboardList } from "lucide-react";

/**
 * Task card with due-date indicator.
 *   task = { id, title, description, deadline, priority }
 */
export function TaskCard({ task, to, testid }) {
  const today = new Date().toISOString().slice(0, 10);
  const overdue = task.deadline && task.deadline < today;
  const dueLabel = task.deadline
    ? new Date(task.deadline).toLocaleDateString("en-IN", { day: "2-digit", month: "short" })
    : "No deadline";

  const Body = (
    <div
      data-testid={testid || `task-card-${task.id}`}
      className="bg-white border border-slate-100 rounded-2xl p-4 hover:shadow-md hover:border-slate-200 transition-all duration-200"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-2xl bg-amber-50 text-amber-600 grid place-items-center shrink-0">
          <ClipboardList className="w-5 h-5" strokeWidth={2.2} />
        </div>
        <div className="min-w-0 flex-1">
          <div className="font-semibold text-slate-900 leading-tight truncate">{task.title}</div>
          {task.description && (
            <div className="text-xs text-slate-500 mt-1 line-clamp-2">{task.description}</div>
          )}
          <div className={`mt-2 inline-flex items-center gap-1 text-[11px] font-semibold ${overdue ? "text-red-600" : "text-slate-500"}`}>
            <Calendar className="w-3.5 h-3.5" strokeWidth={2.4} />
            {overdue ? `Overdue · ${dueLabel}` : `Due ${dueLabel}`}
          </div>
        </div>
      </div>
    </div>
  );
  if (to) return <Link to={to}>{Body}</Link>;
  return Body;
}
